import { create } from 'zustand';
import { speechEngine } from '../utils/SpeechEngine'; // Import our singleton

export const useAudioStore = create((set, get) => ({
  isMuted: true, // Start as muted by default - user MUST click button to unmute

  // The user MUST click a button to unmute for the first time
  toggleMute: () => {
    const newMutedState = !get().isMuted;
    
    if (newMutedState) {
      // If muting, cancel all speech
      speechEngine.cancel();
      console.log('[AudioStore] Audio muted - all speech cancelled');
    } else {
      // If unmuting, this is the user interaction that unlocks audio
      console.log('[AudioStore] Audio unmuted - speech enabled');
      // The first speech attempt will unlock the audio context
    }
    
    set({ isMuted: newMutedState });
  },

  // The ONLY public function for speaking
  speak: (text) => {
    if (get().isMuted) {
      console.log('[AudioStore] Audio is muted, ignoring speech request');
      return;
    }

    if (!text || typeof text !== 'string' || text.trim() === '') {
      return;
    }

    // Delegate to the singleton engine
    speechEngine.speak(text);
  },

  // Helper to clear the queue if needed
  clearQueue: () => {
    speechEngine.clearQueue();
  },
}));
